import { render, staticRenderFns } from "./IcdAliasList.vue?vue&type=template&id=c0264a08&scoped=true&"
import script from "./IcdAliasList.vue?vue&type=script&lang=js&"
export * from "./IcdAliasList.vue?vue&type=script&lang=js&"
import style0 from "./IcdAliasList.vue?vue&type=style&index=0&id=c0264a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0264a08",
  null
  
)

export default component.exports